import { Entity, MicroMClient } from "@mcurros2/microm";
import { PersonalLicenciasFiltersDef } from "./PersonalLicenciasFiltersDef";


export class PersonalLicenciasFilters extends Entity<PersonalLicenciasFiltersDef> {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, new PersonalLicenciasFiltersDef(), parentKeys);
        this.Form = import('./PersonalLicenciasFiltersForm').then((module) => module.PersonalLicenciasFiltersForm);
        this.Title = "Personal Licencias Filters";
    }
}